import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import EditInfoErrorPage from './EditInfoErrorPage';
import EditInfoExpiredPage from './EditInfoExpiredPage';
import EditInfoPage from './EditInfoPage';
import EditInfoRejectPage from './EditInfoRejectPage';
import EditInfoSuccessPage from './EditInfoSuccessPage';

const EditInfoRoute: FuseRouteItemType[] = [
  {
    path: 'edit-info/:token',
    element: <EditInfoPage />,
    auth: null,
  },
  {
    path: 'edit-info/success',
    element: <EditInfoSuccessPage />,
    auth: null,
  },
  {
    path: 'edit-info/expired',
    element: <EditInfoExpiredPage />,
    auth: null,
  },
  {
    path: 'edit-info/reject',
    element: <EditInfoRejectPage />,
    auth: null,
  },
  {
    path: 'edit-info/error',
    element: <EditInfoErrorPage />,
    auth: null,
  },
];

export default EditInfoRoute;
